module.exports = function() {
    if ($("#predictiveSearchModal #search").length > 0) {
        $(document).on('opening touchstart',
            '.remodal',
            function() {
                console.log("Modal is opening");
                $("#predictiveSearchModal #search").focus();
            });
    }
};